// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"558": "228621d3","624": "07a436b5","66": "617f80c1","714": "3c4f7a76","739": "fe9c6c54",}[chunkId] + ".js"
}